import { createSelector } from '@ngrx/store';
import { get } from '../../shared/utils/func';
import { modalState } from './store/modal.name';

export const uiState = createSelector(modalState, get('ui'));

export const selectedArea = createSelector(uiState, get('selectedArea'));

export const selectedInstallTypeClaim = createSelector(uiState, get('selectedClaim'));
